import { useEffect } from 'react';

const COOKIEYES_SRC = 'https://cdn-cookieyes.com/client_data/3dd5abb3a5ab998027865377/script.js';

/**
 * Carica CookieYes solo nel browser reale, non durante react-snap (userAgent "ReactSnap").
 * Lo script in index.html causava pageerror su localhost:45678 e faceva fallire
 * l'intero postbuild (react-snap imposta shuttingDown=true su ogni pageerror).
 */
const CookieYesLoader = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (/ReactSnap/i.test(navigator.userAgent || '')) return;

    const loadScript = () => {
      if (document.getElementById('cookieyes')) return;
      document.documentElement.style.setProperty('--vc-cookie-strip', '5.5rem');
      const script = document.createElement('script');
      script.id = 'cookieyes';
      script.type = 'text/javascript';
      script.src = COOKIEYES_SRC;
      script.async = true;
      document.head.appendChild(script);
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(loadScript, { timeout: 4000 });
    } else {
      window.setTimeout(loadScript, 2500);
    }
  }, []);

  return null;
};

export default CookieYesLoader;
